namespace $ {
	$mol_style_define($bog_ui_divider, {
		margin: {
			bottom: $mol_gap.block,
			top: $mol_gap.block,
		},
		width: '100%',
		border: {
			bottom: {
				width: '2px',
				style: 'solid',
			},
		},
	})
}
